import { generateDialogParams } from '@/lib/generic.utils'
import { DataService } from '@api/index'
const SERVICE = new DataService('licenses')

export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          context.commit('updateAll', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.get(params)
        .then(response => {
          context.commit('updateSingle', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getInlineEditingData(context) {
    const SERVICE = new DataService(`inline-editing/data/licenses/license`)
    return new Promise((resolve, reject) => {
      return SERVICE.getInlineEditingData()
        .then(response => {
          context.commit(
            'data/updateInlineEditingData',
            { namespace: 'licenses', value: response.data.result },
            { root: true }
          )
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  },
  update(context, params) {
    return SERVICE.update(params)
      .then(response => response.data.result)
      .catch(err => err)
  },
  deleteConfirmation(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.getDeleteConfirmation(params)
        .then(response => {
          context.commit(
            'updateGlobalDialogContent',
            generateDialogParams(params.dialogUid, 'deleteSingle', response.data),
            { root: true }
          )
          context.commit('updateGlobalDialogVisibility', { uid: params.dialogUid, value: true }, { root: true })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.delete(params)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
